<template>
    <img :src="currentDisplayImage" v-bind="$attrs" @error="handleErrorImage">
</template>
<script>
import placeholderImage from '@/assets/images/avatars/1.png'
export default {
  props: ['image'],
  data() {
    return {
      placeholderImage,
    }
  },
  methods: {
    setImage(image) {
      this.currentDisplayImage = image
    },
    async handleErrorImage(event) {
      if (event.target) event.target.src = placeholderImage
    },
  },
  async created() {
    this.currentDisplayImage = this.placeholderImage

    if (this.image) {
      var img = new Image()

      img.onload = this.setImage(this.image)

      img.src = this.image
    }
  },
}
</script>